import { getApolloClient } from '@confluence/graphql';
import { SYSTEM_HELP, preloadWebItemLocation } from '@confluence/web-item-location';
import { HelpPanelQuery } from '@confluence/in-product-help';

export const preloadHelpMenu = () =>
	Promise.all([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		getApolloClient().query({ query: HelpPanelQuery }),
	]);
